const resource = '/v1/document-categories';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  getList() {
    return $axios.get(`${resource}/list`);
  },

  getTree(payload = null) {
    return $axios.get(`${resource}/get-tree`, { params: payload});
  },

  updateTree(payload) {
    return $axios.put(`${resource}/update-tree`, payload);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
